import { forwardRef, useRef } from "react";
import {
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
  useDisclosure,
  useMergeRefs,
} from "@chakra-ui/react";
import { EyeIcon, EyeOffIcon } from "@heroicons/react/outline";

export const PasswordInput = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const { isOpen, onToggle } = useDisclosure();
  const inputRef = useRef<HTMLInputElement>(null);

  const mergeRef = useMergeRefs(inputRef, ref);
  const onClickReveal = () => {
    onToggle();
    if (inputRef.current) inputRef.current.focus({ preventScroll: true });
  };

  return (
    <InputGroup>
      <Input
        ref={mergeRef}
        name="password"
        type={isOpen ? "text" : "password"}
        autoComplete="current-password"
        {...props}
      />
      <InputRightElement>
        <IconButton
          variant="link"
          aria-label={isOpen ? "Mask password" : "Reveal password"}
          icon={<Icon as={isOpen ? EyeOffIcon : EyeIcon} />}
          onClick={onClickReveal}
        />
      </InputRightElement>
    </InputGroup>
  );
});

PasswordInput.displayName = 'PasswordInput'
